<template>
  <v-container id="campuses" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          :title="$i18n.t('Helpline Phone/Email')"
          icon="mdi-account-tie"
          class="px-3 py-3 small-icon"
          color="primary"
        >
          <v-container>
            <v-col>
              <v-row v-for="help in helpLines" :key="help.country">
                <v-col cols="12" md="3">
                  <v-text-field
                    :label="$i18n.t('Customer Helpline Number')"
                    class="purple-input"
                    v-model="help.customerHelpline"
                  ></v-text-field>
                  <v-text-field
                    :label="$i18n.t('Driver Helpline Number')"
                    class="purple-input"
                    v-model="help.driverHelpline"
                  ></v-text-field>
                  <v-text-field
                    :label="$i18n.t('Customer Helpline Email')"
                    class="purple-input"
                    v-model="help.customerSupportEmail"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    :label="$i18n.t('SOS Notification Phone No')"
                    class="purple-input"
                    v-model="help.sosPhone"
                  ></v-text-field>
                  <v-text-field
                    :label="$i18n.t('SOS Notification Email')"
                    class="purple-input"
                    v-model="help.sosEmail"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <z-country-select class="purple-input" v-model="help.country"></z-country-select>
                  <z-city-select
                    class="purple-input"
                    v-model="help.cityGroup"
                    multiple
                    :country="help.country"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <z-client-select class="purple-input" v-model="help.client_id" />
                </v-col>

                <v-col cols="12" md="1">
                  <v-checkbox v-model="help.isDefault" :label="$i18n.t('Default')"></v-checkbox>
                  <v-btn @click="remove()">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-btn small class="float-right" color="blue" @click="add()">
                  <v-icon>mdi-plus</v-icon>
                  {{ $i18n.t("Add Helpline") }}
                </v-btn>
              </v-row>
            </v-col>
          </v-container>
          <v-col cols="12" class="text-right">
            <v-btn color="success" class="mr-0" @click="save()" :loading="loading">
              <h3>{{ $i18n.t("Save") }}</h3>
            </v-btn>
          </v-col>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  corporateConfig = {
    helpLines: [],
  };
  url = "/api/corp/config/get";
  helpLines = [];

  get loading() {
    return common.loading;
  }

  add() {
    if (this.helpLines == null) {
      this.helpLines = [];
    }

    this.helpLines.push({
      isDefault: false,
    });
  }

  async mounted() {
    try {
      this.corporateConfig = await doGet(this.url);
      this.helpLines = this.corporateConfig.helpLines;
    } catch (e) {
      common.setError(e.message);
    }
  }
  remove(_index) {
    this.helpLines.splice(_index, 1);
  }

  async save() {
    try {
      common.setLoading(true);
      this.corporateConfig.helpLines = this.helpLines;
      // console.log(this.corporateConfig);
      await doPost("/api/corp/config/helpline/save", this.corporateConfig);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
#bookingCheckbox {
  margin-left: 20px;
  margin-right: 20px;
  justify-content: space-between;
}
</style>
